import {materialPermissions} from '../../../../utils/materialPermissions';
import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import axios from 'axios';

const MaterialSupplierPriceListComponent = ({t}) => {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState({first: 0, rows: Number(process.env.REACT_APP_LIST_ROW_DEFAULT), page: 0, sortField: 'valid_from', sortOrder: -1, filters: {}});
  const headers = {'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')};
  const canWrite = materialPermissions().write;

  const load = () => {
    setLoading(true);
    const query = window.App.transformQueryParams(lazyParams);
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/material-supplier-price' + query, {headers})
      .then(r => { setItems(r.data.data.items); setTotalRecords(r.data.data.total_item_count); })
      .catch(e => window.App.toastShow('error', t('error'), e.toString(), '', e.response))
      .finally(() => setLoading(false));
  };
  useEffect(load, [lazyParams, window.App.state.rerenderMaterialSupplierPriceList]);

  const textFilter = (field) => ({value: lazyParams.filters?.[field]?.value || '', onChange: e => setLazyParams({...lazyParams, first: 0, filters: {...lazyParams.filters, [field]: {value: e.target.value, matchMode: 'contains'}}})});
  const formatCurrency = (currency, amount) => window.App?.currencyFormatter
    ? window.App.currencyFormatter(currency, Number(amount || 0))
    : `${amount || 0} ${currency || ''}`;
  const actions = row => <>
    <Button icon="pi pi-pencil" className="p-button-warning p-mr-2" tooltip={t('edit')} onClick={() => history.push('/inventory/material-supplier-price/update/' + row.id)}/>
    <Button icon="pi pi-trash" className="p-button-danger" tooltip={t('delete')} onClick={() => {
      if (!window.confirm(t('confirmDeleteMaterialSupplierPrice'))) return;
      axios.delete(process.env.REACT_APP_API_HOST + '/api/v2/material-supplier-price/' + row.id, {headers})
        .then(() => { window.App.toastShow('success', t('toastDeleteSuccess')); load(); })
        .catch(e => window.App.toastShow('error', t('error'), e.toString(), '', e.response));
    }}/>
  </>;

  return <DataTable value={items} lazy paginator loading={loading} first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords}
    onPage={e => setLazyParams({...lazyParams, ...e})} onSort={e => setLazyParams({...lazyParams, ...e})}
    sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} filterDisplay="row" responsiveLayout="scroll" stripedRows emptyMessage={t('noResults')}>
    <Column field="supplier_name" header={t('fieldSupplier')} filter filterElement={<input className="p-inputtext p-component" {...textFilter('supplier_name')}/>} body={r => r.supplier?.name}/>
    <Column field="material_upc" header={t('upc')} filter filterElement={<input className="p-inputtext p-component" {...textFilter('material_upc')}/>} body={r => r.material?.upc}/>
    <Column field="material_name" header={t('fieldMaterial')} filter filterElement={<input className="p-inputtext p-component" {...textFilter('material_name')}/>} body={r => r.material?.name}/>
    <Column field="price" header={t('fieldPrice')} sortable body={r => formatCurrency(r.currency, r.price)}/>
    <Column field="valid_from" header={t('fieldValidFrom')} sortable body={r => window.App.formatDateValue(r.valid_from)}/>
    <Column field="valid_to" header={t('fieldValidTo')} sortable body={r => window.App.formatDateValue(r.valid_to)}/>
    {canWrite && <Column body={actions}/>}
  </DataTable>;
};
export default withTranslation('common')(MaterialSupplierPriceListComponent);
